if (!customElements.get('sticky-cart-bar')) {
  customElements.define(
    'sticky-cart-bar',
    class StickyCartBar extends HTMLElement {
      connectedCallback() {
        this.titleEl = this.querySelector('[data-sticky-cart-title]');
        this.saveEl = this.querySelector('[data-sticky-cart-save]');
        this.tagsEl = this.querySelector('.sticky-cart-bar__tags');
        this.submitButton = this.querySelector('[data-sticky-cart-submit]');
        this.targetButton = document.getElementById(this.dataset.targetId);
        this.ticking = false;

        if (this.submitButton && this.targetButton) {
          this.submitButton.addEventListener('click', () => {
            this.targetButton.click();
          });
        }

        document.addEventListener('bundle-picker:select', this.onBundleSelect.bind(this));

        if (this.targetButton) {
          this.onScroll = this.onScroll.bind(this);
          this.onResize = this.onResize.bind(this);

          const start = () => {
            this.updateTargetY();
            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onResize);
            this.checkPosition();
          };

          if (document.readyState === 'complete') {
            start();
          } else {
            window.addEventListener('load', start, { once: true });
          }
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      updateTargetY() {
        // the constant: the add-to-cart button's vertical position in the full document
        const rect = this.targetButton.getBoundingClientRect();
        this.targetY = rect.top + window.scrollY;
      }

      onResize() {
        this.updateTargetY();
        this.checkPosition();
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.checkPosition();
          this.ticking = false;
        });
      }

      checkPosition() {
        // the variable: how far down the page the user is currently scrolled
        const currentY = window.scrollY;

        if (currentY < this.targetY) {
          this.classList.remove('sticky-cart-bar--visible');
        } else {
          this.classList.add('sticky-cart-bar--visible');
        }
      }

      onBundleSelect(event) {
        if (this.titleEl && event.detail.label) {
          this.titleEl.textContent = event.detail.label;
        }

        if (this.tagsEl) {
          this.tagsEl.hidden = !event.detail.hasFreebies;
        }

        if (this.saveEl) {
          if (event.detail.savePercent > 0) {
            this.saveEl.textContent = `Save ${event.detail.savePercent}%`;
            this.saveEl.hidden = false;
          } else {
            this.saveEl.hidden = true;
          }
        }

        if (this.submitButton) {
          this.submitButton.disabled = this.targetButton?.disabled ?? false;
        }
      }
    }
  );
}
